/* lua.js generated code 0.3.0 */

var [Panel, PanelEvent] = unpack(require("clover/panel/MarkPriseWxChestPanel"))
var [Button, ButtonEvent] = unpack(require("clover/scene/component/homescene/MarkPriseWxChestButton"))
var MarkPriseWxChestLogic = xClass("MarkPriseWxChestLogic")
let ShareUtil = require("clover/utils/ShareUtil")
var priseButton = null
var buttonDelegateSet = table()
MarkPriseWxChestLogic.prototype.ctor = function () {
    var self = this
    self.isBusy = false
}
// pos = {p00, p11}
MarkPriseWxChestLogic.prototype.start = function (finishCallback, showPos, hidePos, data) {
    var self = this

    function onHttpResponse(data, noToast) {
        function removeBtn(reason) {
            if (reason) {
                Toast.make(reason)
            }
            self.removeMarkPrise()
            if (priseButton && priseButton.nodeExist) {
                priseButton.setHided(true)
            }
            if (finishCallback) {
                finishCallback()
            }
        }
        if (!data) {
            removeBtn()
            return
        }
        self.clicked = data.hasClicked

        if (!data.rewards || $len(data.rewards) == 0) {
            // removeBtn("今天没有限时宝箱")
            removeBtn()
            return
        }

        if (data.countdown <= 0) {
            let toastText = noToast ? null : "倒计时结束"
            removeBtn(toastText)
            return
        }

        if (data.hasFetch) {
            let toastText = noToast ? null : "奖励已经领取过了"
            removeBtn(toastText)
            return
        }

        if (priseButton && priseButton.nodeExist) {
            priseButton.setHided(true)
        }
        for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
            if (v && v.nodeExist) {
                v.setHided(true)
            }
        }
        self.finishCallback = finishCallback

        let startTime = Localhost.time()
        let endTime = startTime + data.countdown
        let canFetch = data.hasClicked && !data.hasFetch
        self.showPanel(self.getGoodsInfo(data.rewards, startTime, endTime, canFetch), showPos, hidePos)
        self.chestIndex = data.chestIndex
        
        // 检查是否已点击未领取
        self.shakeBoxCanGetReward()
    }

    if (data) {
        if (data.rewards && $len(data.rewards)) {
            self.addMarkPrise(data.rewards, null, data.countdown, data.hasClicked)
        } else {
            // 没有宝箱
            self.removeMarkPrise()
        }
        self.chestIndex = data.chestIndex
        self.clicked = data.hasClicked
        
        // 检查是否已点击未领取
        self.shakeBoxCanGetReward()
        onHttpResponse(data, true)
    } else {
        self.removeMarkPrise()
        onHttpResponse()
    }
}
MarkPriseWxChestLogic.prototype.onFinish = function () {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.setHided(false)
    }
    if (priseButton) {
        priseButton.setClicked(self.clicked)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v && v.nodeExist) {
            v.setHided(false)
        }
        if (v) {
            priseButton.setClicked(self.clicked)
        }
    }
    if (self.finishCallback) {
        self.finishCallback()
    }
}
MarkPriseWxChestLogic.prototype.playButtonShakeAnim = function (shakeForClick) {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.shakeBox(shakeForClick)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v && v.nodeExist) {
            v.shakeBox(shakeForClick)
        }
    }
}
MarkPriseWxChestLogic.prototype.showPanel = function (info, showPos, hidePos) {
    var self = this
    function callback(panel) {
        panel.on(PanelEvent.Close, function (evt) {
            if (self.isBusy) {
                return 
            }
            self.isBusy = true
            evt.target.onClose((hidePos || table()).p00, (hidePos || table()).p11, function () {
                self.onFinish()
                self.playButtonShakeAnim()
            })
        })
        panel.on(PanelEvent.Buy, function (evt) {
            runShare();
        })
        panel.on(PanelEvent.Get, function (evt) {
            DCAssist.userTrack("Mark", "click_chest_open", {
                chestIndex: self.chestIndex
            })

            // 奖励放入宝箱
            let http = MarkPriseWxChestHttp.new()
            http.addEventListener(Events.kComplete, function (evt) {
                let data = evt.data
                let rewards = data.rewards
                for (var k = 1, v = rewards[1]; v; k++, v = rewards[k]) {
                    UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK_WX_SHARE)
                }
                self.removeMarkPrise()
                panel.playPropAnim(function () {
                    panel.onClose(null, null, function () {
                        self.onFinish()
                    })
                })
            })
            http.addEventListener(Events.kError, function () {
                Toast.make("奖励领取失败")
            })
            http.addEventListener(Events.kCancel, function () {
                Toast.make("奖励领取取消")
            })
            http.load()

        })
        panel.on(PanelEvent.TimeUp, function (evt) {
            if (self.isBusy) {
                return 
            }
            self.isBusy = true
            if (!self.checkMarkPrise()[0]) {
                self.removeMarkPrise()
                evt.target.onClose(null, null, function () {
                    self.onFinish()
                })
            }
        })
        self.isBusy = true
        panel.popup(true, false, (showPos || table()).p00, (showPos || table()).p11, function () {
            self.isBusy = false
        })
    }
    Panel.asyncCreate(info, callback)
}
MarkPriseWxChestLogic.prototype.getGoodsInfo = function (rewards, startTime, endTime, canFetch) {
    var self = this
    return {
        rewards: clone(rewards),
        startTime: startTime,
        endTime: endTime,
        canFetch: canFetch,
        props: clone(rewards)
    }
}
MarkPriseWxChestLogic.prototype.checkMarkPrise = function () {
    var self = this
    let txt = UserLocalSettings.getSetting("MarkPriseWxChestGoodsId")
    let rewards
    try {
        rewards = JSON.parse(txt)
    } catch (e) {

    }
    var startTime = UserLocalSettings.getSetting("MarkPriseWxChestStartTime", 0)
    let endTime = UserLocalSettings.getSetting("MarkPriseWxChestEndTime", 0)
    if (Localhost.time() < endTime) {
        let clicked = UserLocalSettings.getSetting("MarkPriseWxChestClicked")
        return [rewards, startTime, endTime, clicked]
    } else {
        self.removeMarkPrise()
        self.removeButton()
    }
    return [null, null, null, null]
}
MarkPriseWxChestLogic.prototype.addMarkPrise = function (rewards, time, countdown, clicked) {
    var self = this
    UserLocalSettings.setSetting("MarkPriseWxChestGoodsId", JSON.stringify(rewards))
    
    if (time == null || time == undefined) {
        time = tostring(Localhost.time())
    }
    time = tonumber(time)
    UserLocalSettings.setSetting("MarkPriseWxChestStartTime", time)

    if (countdown == null || countdown == undefined) {
        countdown = 0
    }
    countdown = tonumber(countdown)
    let endTime = time + countdown
    UserLocalSettings.setSetting("MarkPriseWxChestEndTime", endTime)
    
    UserLocalSettings.setSetting("MarkPriseWxChestClicked", clicked)

    if (priseButton) {
        priseButton.setEndTime(endTime)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v.nodeExist) {
            v.setEndTime(endTime)
        }
    }
    self.createButton()
}
MarkPriseWxChestLogic.prototype.removeMarkPrise = function () {
    var self = this
    self.removeButton()
    UserLocalSettings.removeSetting("MarkPriseWxChestGoodsId")
    UserLocalSettings.removeSetting("MarkPriseWxChestStartTime")
    UserLocalSettings.removeSetting("MarkPriseWxChestEndTime")
    UserLocalSettings.removeSetting("MarkPriseWxChestClicked")
}
MarkPriseWxChestLogic.prototype.getMarkPrise = function () {
    var self = this
    // WARN: maybe multi result
    let txt = UserLocalSettings.getSetting("MarkPriseWxChestGoodsId")
    try {
        let rewards = JSON.parse(txt)
        return [rewards, tonumber(UserLocalSettings.getSetting("MarkPriseWxChestStartTime", 0)),
            tonumber(UserLocalSettings.getSetting("MarkPriseWxChestEndTime", 0)),
            tonumber(UserLocalSettings.getSetting("MarkPriseWxChestClicked"))
        ]
    } catch (e) {
        return [null, null, null]
    }
    
}
MarkPriseWxChestLogic.prototype.shakeBoxCanGetReward = function () {
    let self = this
    if (!self.clicked) {
        return
    }

    if (self.shakeTimeout) {
        return
    }
    function shakeBox() {
        if (self.clicked) {
            self.playButtonShakeAnim(true)
        } else if (self.shakeTimeout) {
            clearInterval(self.shakeTimeout)
            self.shakeTimeout = null
        }
    }
    self.shakeTimeout = setInterval(shakeBox, 2000)
}
MarkPriseWxChestLogic.prototype.createButtonAsyncUpdate = function () {
    let self = this
    self.removeMarkPrise()
    self.createButton()
}

MarkPriseWxChestLogic.prototype.createButton = function () {
    var self = this
    if(UserManager.getInstance().shouldShowBreakIceIcon()){
        return null
    }
    if (priseButton) {
        var [_, startTime, endTime, clicked] = self.checkMarkPrise()
        if (startTime) {
            priseButton.setEndTime(endTime)
            priseButton.setClicked(clicked)
        }
        return priseButton
    }
    var [_, startTime, endTime, clicked] = self.checkMarkPrise()
    if (!startTime) {
        return null
    }
    priseButton = Button.create(endTime, clicked)
    priseButton.on(ButtonEvent.TimeUp, function () {
        self.checkMarkPrise()
    })
    var HomeScene = require("clover/scene/HomeScene")
    var vSize = cc.Director.getInstance().getVisibleSize()
    // priseButton.setPosition(cc.p(80, 60))
    priseButton.setPosition(cc.p(80, 80))
    HomeScene.getInstance().addChild(priseButton)
    return priseButton
}
MarkPriseWxChestLogic.prototype.delegateButton = function (button) {
    var self = this
    table.insert(buttonDelegateSet, button)
}
MarkPriseWxChestLogic.prototype.removeButtonDelegation = function (button) {
    var self = this
    table.removebyvalue(buttonDelegateSet, button)
}
MarkPriseWxChestLogic.prototype.removeButton = function () {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.removeFromParent(true)
        priseButton = null
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v.nodeExist) {
            v.removeFromParent(true)
        }
    }
    buttonDelegateSet = table()
}

function runShare() {
    let onFail = ()=> { Toast.make(getText("activity.sharefailed")); }
    ShareUtil.clickMark(null, onFail, onFail);
}

module.exports = MarkPriseWxChestLogic
